import { useState, useEffect } from "react";
import Select from "react-select"; // Import react-select
import { DataState } from "../../context/DataProvider";
import Button from "../custom/Button";
import { customDropdownStyle } from "../../utils/constants";
import {submitClarificationAndCreateWorflow} from "../../services/workflowApi";
import toast from "react-hot-toast";

const QuestionForm = ({
  handleShowTestScreen,
  closeModal,
  setShowQuestionForm,
  clarificationQuestions,
  clearStates,
  workflowId
}) => {
  const {
    // clarificationQuestions,
    // setNeedBotFetch,
    // submitClarificationAnswersAndCreateBotSteps,
    isBusy,
    userGoogleId,
  } = DataState();

  const dropdownOptions = [
    { value: "ai", label: "Have AI generate value for this field" },
    { value: "manual", label: "Set a specific value" },
  ];

  const [answers, setAnswers] = useState({});
  const [inputVisibility, setInputVisibility] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  
  // Function to submit clarification answers and create bot steps
  const submitClarificationAnswersAndCreateBotSteps = async () => {
    try {
  
      // Prepare the data to be sent for creating bot steps
      // const stepsData = {
      //   bot_id: botCreationId,
      //   clarification_questions: clarificationQuestions,
      //   user_google_id: userGoogleId,
      //   // Add any additional data needed for creating bot steps
      // };

      // Submit the answers and create the bot steps
      console.log("Workflow id before clarification quqestion submission:", workflowId)
      const stepsResponse = await submitClarificationAndCreateWorflow(userGoogleId, workflowId, clarificationQuestions);
      console.log("Bot Steps", stepsResponse);

      // Optionally, you can handle the response further, such as updating the UI or state

      // setIsBusy(false);
      return stepsResponse;
    } catch (error) {
      console.error(
        "Error in submitting clarification answers and creating bot steps:",
        error
      );
      toast.error(
        "Error in submitting clarification answers and creating bot steps"
      );

      // setIsBusy(false);
      throw error;
    }
  };

  // Initialize the selected option to "ai" (AI as the default selection)
  useEffect(() => {
    const initialSelectedOptions = clarificationQuestions.reduce((acc, question) => {
      acc[question.id] = dropdownOptions[0]; // Set AI option as default
      return acc;
    }, {});
    setSelectedOptions(initialSelectedOptions);

    const initialAnswers = clarificationQuestions.reduce((acc, question) => {
      acc[question.id] = "Have AI generate value for this field"; // Set default AI answer
      return acc;
    }, {});
    setAnswers(initialAnswers);
  }, [clarificationQuestions]);

  const handleSelectChange = (id, selectedOption) => {
    setSelectedOptions((prevOptions) => ({
      ...prevOptions,
      [id]: selectedOption,
    }));

    if (selectedOption.value === "ai") {
      // Set the answer as "Have AI generate value for this field"
      setAnswers((prevAnswers) => ({
        ...prevAnswers,
        [id]: "Have AI generate value for this field",
      }));
      setInputVisibility((prevVisibility) => ({
        ...prevVisibility,
        [id]: false, // Hide input field if AI option is selected
      }));
    } else {
      setInputVisibility((prevVisibility) => ({
        ...prevVisibility,
        [id]: true, // Show input field for manual input
      }));
      setAnswers((prevAnswers) => ({
        ...prevAnswers,
        [id]: "", // Clear the answer for manual input
      }));
    }
  };

  const handleChange = (id, event) => {
    setAnswers({
      ...answers,
      [id]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    setErrorMessage("");
    try {
      if (isBusy) {
        return;
      }
      event.preventDefault();
      const newClarificationQuestions = [...clarificationQuestions];

      for (let question of newClarificationQuestions) {
        question.answer = answers[question.id] || "not answered";
      }
      const response = await submitClarificationAnswersAndCreateBotSteps();

      if (response.error) {
        setErrorMessage(JSON.stringify(response.error));
        return;
      }

      // setNeedBotFetch(true);
      setAnswers({});
      clearStates();
      setShowQuestionForm(false);
      closeModal();
    } catch (error) {
      setErrorMessage("Error saving data. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-h-full overflow-auto">
      <form onSubmit={handleSubmit}>
        {clarificationQuestions.map((question) => (
          <div key={question.id} className="mb-4">
            <label className="block text-white font-medium mb-2">
              {question.question}
            </label>

            {/* Dropdown for AI or manual value with AI as default */}
            <Select
              value={selectedOptions[question.id]} // Set default value to "ai"
              options={dropdownOptions}
              onChange={(selectedOption) =>
                handleSelectChange(question.id, selectedOption)
              }
              styles={customDropdownStyle}
              className="mb-2"
            />

            {/* Input field (only visible when manual option is selected) */}
            {inputVisibility[question.id] && (
              <input
                type="text"
                className="p-2 rounded-md bg-zinc-800 text-white outline-none w-full"
                value={answers[question.id] || ""}
                onChange={(event) => handleChange(question.id, event)}
              />
            )}
          </div>
        ))}
        {errorMessage && <p className="text-red-500 mb-4">{errorMessage}</p>}
        <div className="w-full flex justify-end">
          <Button loading={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default QuestionForm;
